import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Practice from "@/pages/Practice";
import PracticeDetail from "@/pages/PracticeDetail";
import Team from "@/pages/Team";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import Matters from "@/pages/Matters";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import Privacy from "@/pages/Privacy";
import PartnerProfile from "@/pages/PartnerProfile";
import ScrollToTop from "@/components/layout/ScrollToTop";
import { LangProvider } from "@/i18n/LangContext";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LangProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/practice-areas" element={<Practice />} />
                <Route path="/practice-areas/:slug" element={<PracticeDetail />} />
                <Route path="/team" element={<Team />} />
                <Route path="/team/:slug" element={<PartnerProfile />} />
                <Route path="/matters" element={<Matters />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/insights/:slug" element={<InsightArticle />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </LangProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
